module.exports = __webpack_public_path__ + "static/media/walking-dog-graphic.17eb4d8b.svg";